import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getDefaultOrderFilter } from 'components/Workplaces/Order/Order';
import { Dictionary } from 'lodash';
import { useSidebarContext } from 'providers/SidebarProvider';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import SidebarMenuItem from '../Sidebar/SidebarMenuItem/SidebarMenuItem';

type OrderStatusesSidebarMenuItemProps = {
    code: string;
    translateCode: string;
    isImportant: boolean;
    icon: string;
    counters?: Dictionary<number>;
    countVisible?: boolean | undefined;
};

const OrderStatusesSidebarMenuItem = ({
    code,
    translateCode,
    isImportant,
    icon,
    counters,
    countVisible = true,
}: OrderStatusesSidebarMenuItemProps) => {
    const { t } = useTranslation();
    const statusCode = code === 'status-all' ? undefined : code;
    const [searchParams] = useSearchParams();
    const { currentTab, setCurrentTab } = useSidebarContext();

    const link = useMemo(() => {
        const params = new URLSearchParams(searchParams);
        searchParams.forEach((_, key) => {
            if (['pageSize', 'ed', 'sd'].indexOf(key) === -1) {
                params.delete(key);
            }
        });

        const pageSize = params.get('pageSize');
        const ed = params.get('ed');
        const sd = params.get('sd');

        if (!ed || !sd) {
            const defautFilter = getDefaultOrderFilter();
            params.set('sd', defautFilter.sd);
            params.set('ed', defautFilter.ed);
        }

        if (statusCode) {
            params.set('orderStatuses', statusCode);
        }

        params.set('pageNum', '1');

        if (!pageSize) {
            params.set('pageSize', '10');
        }

        return '/order?' + params.toString();
    }, [searchParams]);

    return (
        <SidebarMenuItem
            icon={icon ? <FontAwesomeIcon icon={icon.split('_') as IconProp} /> : <></>}
            value={t(translateCode)}
            key={code}
            id={code}
            link={link}
            isActive={code === currentTab}
            onClick={() => {
                if (code) {
                    setCurrentTab(code);
                }
            }}
            isVisiblePin={false}
            overflownElementClassName="sidebar-menu-item__link"
        >
            <div className="row">
                <div className={`sidebar-menu-item__link ${countVisible ? 'col-9' : ''}`}>
                    {t(translateCode)}
                </div>
                {countVisible && (
                    <div className="col-3">
                        <span
                            className={
                                'badge float-end ' +
                                (isImportant && (counters?.[code] ?? 0)
                                    ? 'bg-danger blink'
                                    : 'bg-primary')
                            }
                        >
                            {counters?.[code] ?? 0}
                        </span>
                    </div>
                )}
            </div>
        </SidebarMenuItem>
    );
};

export default OrderStatusesSidebarMenuItem;
